import React from 'react';
import { useTranslation } from '@/i18n/I18nContext';
import { Globe } from 'lucide-react';

const FLAGS = { it: '🇮🇹', de: '🇩🇪', en: '🇬🇧', es: '🇪🇸' };

export function LanguageSelector({ className = '' }) {
  const { lang, setLang, supportedLangs, t } = useTranslation();

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="ui-language-selector">
      <Globe className="h-4 w-4 text-slate-400" />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="text-xs rounded border border-gray-300 bg-white px-2 py-1 focus:outline-none focus:ring-1 focus:ring-emerald-500"
        data-testid="ui-language-select"
        aria-label={t('uiLanguage.selectorTitle')}
      >
        {supportedLangs.map((l) => (
          <option key={l} value={l}>
            {FLAGS[l]} {l.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}
